module.exports = __webpack_public_path__ + "img/抚州市第二人民医院.0259b321.png";